module.exports = "/images/TXR Preview_pages-4.jpg?4d774a4ba73edf683f1323873d5ac92f";